import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
  create_inventory,
  get_inventory,
  update_inventory,
} from "../../../../Controllers/Inventory/Batch";
import forms from "../../../../Data/Forms/Inventory/Batch/forms";
import headers from "../../../../Data/Forms/Inventory/Batch/headers";
import Loadercomponent from "../../../../Componets/Loader";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Inventoryunittable from "../../../../Data/Forms/Inventory/Batch/table";
import { get_product } from "../../../../Controllers/Products/Products";

const InventoryBatchForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [details, setDetails] = useState([]);
  const [stock, setStock] = useState([]);

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [values, setValues] = useState(forms);
  const [selectedProduct, setSelectedProduct] = useState("");

  const getformdata = async (data) => {
    if (data?.product) {
      if (selectedProduct != data?.product) {
        setSelectedProduct(data?.product);

        const params = {
          id: data?.product,
        };

        const product = await get_product(params);

        if (product?.status) {
          let unit_details = [];

          let purchase_price = product?.data?.purchase_price
            ? product?.data?.purchase_price
            : "";
          let price_per_unit = product?.data?.purchase_price
            ? product?.data?.purchase_price
            : "";
          let sale_price = product?.data?.sale_price
            ? product?.data?.sale_price
            : "";
          let wholesale_price = product?.data?.wholesale_price
            ? product?.data?.wholesale_price
            : "";
          let tax = product?.data?.tax ? product?.data?.tax : "";
          values[1].options[4].form.category = tax.category;

          values[1].options[0].form.value = purchase_price;
          values[1].options[1].form.value = price_per_unit;
          values[1].options[2].form.value = sale_price;
          values[1].options[3].form.value = wholesale_price;

          values[1].options[4].form.value = tax._id;
          values[1].options[4].form.options = tax?._id
            ? [{ value: tax?._id, label: tax?.name }]
            : null;

          setValues([...values]);

          if (product?.data?.product_units_details?.length > 0) {
            product?.data?.product_units_details?.map((value, index) => {
              unit_details?.push({
                id: "",
                name: value?.name?.name,
                options: "",
                conversion: value?.conversion,
                purchase_price: "",
                sale_price: "",
                wholesale_price: "",
                stock: "",
              });
            });
          } else {
            unit_details = [];
          }

          setDetails(unit_details);
        }
      }
    } else {
      setDetails([]);
    }

    //no id
    if (!id) {
      if (data?.stock) {
        if (stock != data?.stock) {
          setStock(data?.stock);

          if (details?.length > 0) {
            let unit_details = [];

            details?.map((value, index) => {
              unit_details?.push({
                id: "",
                name: value?.name,
                options: "",
                conversion: value?.conversion,
                purchase_price: value?.purchase_price,
                price_per_unit: value?.price_per_unit,
                sale_price: value?.sale_price,
                wholesale_price: value?.wholesale_price,
                stock:
                  parseFloat(data?.stock || 0) *
                  parseFloat(value?.conversion || 0),
              });
            });

            setDetails(unit_details);
          }
        }
      }
    }

    //if id
    if (id) {
      if (data?.stock) {
        if (stock != data?.stock) {
          setStock(data?.stock);

          if (details?.length > 0) {
            let unit_details = [];

            details?.map((value, index) => {
              unit_details?.push({
                name: value?.name,
                conversion: value?.conversion,
                purchase_price:
                  parseFloat(data?.purchase_price || 0) /
                  parseFloat(value?.conversion || 0),
                price_per_unit:
                  parseFloat(data?.price_per_unit || 0) /
                  parseFloat(value?.conversion || 0),
                sale_price:
                  parseFloat(data?.sale_price || 0) /
                  parseFloat(value?.conversion || 0),
                wholesale_price:
                  parseFloat(data?.wholesale_price || 0) /
                  parseFloat(value?.conversion || 0),
                stock:
                  parseFloat(data?.stock || 0) *
                  parseFloat(value?.conversion || 0),
              });
            });

            setDetails(unit_details);
          }
        }
      }
    }
  };

  const formdata = async (data) => {

    if (buttonLoader) return;

    if (data?.status) {
      setButtonLoader(true);

      const inventory = id
        ? await update_inventory({ ...data?.data, id: id, details: details })
        : await create_inventory({ ...data?.data, details: details });

      if (inventory?.status) {
        // if (id) {
        //   navigate(-1);
        // }
        navigate(-1);
        toast?.success(inventory?.message);
        setButtonLoader(false);
      } else {
        setButtonLoader(false);
        if (inventory?.status_code == 403) {
          window.location.href = "/unauthorized";
        } else {
          toast?.error(inventory?.message);
        }
      }
    }
  };

  const handleData = async (inventory) => {
    let number = inventory?.number ? inventory?.number : "";
    let product = inventory?.product?._id ? inventory?.product?._id : "";
    let supplier = inventory?.supplier?._id ? inventory?.supplier?._id : null;
    let barcode = inventory?.barcode ? inventory?.barcode : "";
    let purchase_price = inventory?.purchase_price
      ? inventory?.purchase_price
      : 0;
    let price_per_unit = inventory?.price_per_unit
      ? inventory?.price_per_unit
      : 0;
    let sale_price = inventory?.sale_price ? inventory?.sale_price : 0;
    let wholesale_price = inventory?.wholesale_price
      ? inventory?.wholesale_price
      : "";
    let tax = inventory?.tax?._id ? inventory?.tax?._id : null;
    let tax_option = inventory?.tax?._id
      ? [{ value: inventory?.tax?._id, label: inventory?.tax?.name }]
      : null;

    let category = inventory?.product?.category?._id ? inventory?.product?.category?._id : null;

    let stock = inventory?.stock ? inventory?.stock : 0;
    let manufacture_date = inventory?.manufacture_date
      ? inventory?.manufacture_date
      : "";
    let expiry_date = inventory?.expiry_date ? inventory?.expiry_date : "";
    let status = inventory?.status ? inventory?.status : 0;

    let product_option = inventory?.product?._id
      ? [{ value: inventory?.product?._id, label: inventory?.product?.name }]
      : null;
    let supplier_option = inventory?.supplier?._id
      ? [{ value: inventory?.supplier?._id, label: inventory?.supplier?.name }]
      : null;

    values[0].options[0].form.value = number;
    values[0].options[1].form.value = product;
    values[0].options[1].form.options = product_option;
    values[0].options[2].form.value = barcode;
    values[0].options[3].form.value = supplier;
    values[0].options[3].form.options = supplier_option;

    values[1].options[0].form.value = purchase_price;
    values[1].options[1].form.value = price_per_unit;
    values[1].options[2].form.value = sale_price;
    values[1].options[3].form.value = wholesale_price;
    values[1].options[4].form.value = tax;
    values[1].options[4].form.options = tax_option;
    values[1].options[4].form.category = category;

    values[2].options[0].form.value = stock;

    values[3].options[0].form.value = manufacture_date;
    values[3].options[1].form.value = expiry_date;

    values[4].options[0].form.value = status;

    if (inventory?.inventory_unit_details?.length > 0) {
      let inventory_unit_details = [];
      inventory?.inventory_unit_details?.map((v, i) => {
        inventory_unit_details?.push({
          id: v?._id,
          name: v?.name,
          conversion: v?.conversion,
          purchase_price: v?.purchase_price,
          price_per_unit: v?.price_per_unit,
          sale_price: v?.sale_price,
          wholesale_price: v?.wholesale_price,
          stock: v?.stock,
        });
      });
      setDetails([...inventory_unit_details]);
    }

    setLoader(false);
    setSelectedProduct(product);
    setValues([...values]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const inventory = await get_inventory(data);
      if (inventory?.status) {
        handleData(inventory?.data);
      } else {
        if (inventory?.status_code == 403) {
          window.location.href = "/unauthorized";
        } else {
          toast?.error(inventory?.message);
        }
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
          getformdata={getformdata}
        >
          <Bodycomponent>
            <Titlecomponent index={1} title={"Units"} />
            <Formdata>
              <Headercomponent index={0} name={"Details"} required={false} />
              <Inventoryunittable
                form={values}
                setForm={setValues}
                details={details}
                setDetails={setDetails}
              />
            </Formdata>
          </Bodycomponent>
        </Forms>
      </Loadercomponent>
    </Header>
  );
};

export default InventoryBatchForm;
